import { render, staticRenderFns } from "./RelanceConfigurationPage.vue?vue&type=template&id=9e1bf2be&"
import script from "../../../public/js/img/Discoveryjs/EngagementFinder/RelanceConfiguration.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/EngagementFinder/RelanceConfiguration.js?vue&type=script&lang=js&"
import style0 from "./RelanceConfigurationPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports